import { useRouter } from "next/router";
import qs from "qs";

import { QueryParameter as TopicAndAuthorQueryParameter } from "~/components/letter-list/consts";
import { config } from "~/data";
import { sanitizedParametersByKeys } from "~/lib/router/hooks";
import { getAbsoluteUrl, isValidUrl } from "~/lib/utils";

export const SanitizedUrlKeys = [TopicAndAuthorQueryParameter];

export const useCanonicalUrl = (url?: string) => {
  const router = useRouter();
  const canonicalUrl = getAbsoluteUrl(url ?? router.asPath, config.general.canonicalBaseUrl);
  if (isValidUrl(canonicalUrl)) {
    const url = new URL(canonicalUrl);
    const { sanitizedQueryString } = sanitizedParametersByKeys(SanitizedUrlKeys, url.search);
    url.search = qs.stringify({ ...sanitizedQueryString });
    return {
      canonicalUrl: url.toString(),
    };
  }

  return {
    canonicalUrl,
  };
};
